import classnames from "classnames";
import { BeatLoader } from "react-spinners";
import styles from "./Loading.module.scss";

export function Loading({ left, height = "auto", size }) {
    return (
        <div
            className={classnames(styles.loading, { [styles.left]: left })}
            style={{ height: height != "auto" ? height : undefined }}
        >
            <BeatLoader color="var(--spinner-color)" size={size} />
        </div>
    );
}
